import React, {useState} from 'react'
import './todos.less'
import {useIntl} from 'react-intl'
import {Button, Checkbox, List} from 'antd'
import {PlantCollection} from '../../entities/plant'
import {SelectCollectionsModal} from './SelectCollectionsModal'

export type CheckableListProps = {
  elements?: {id: number; name: string}[]
  checkedElements: Partial<Record<number, boolean>>
  setCheckedElements: (checkedElements: Partial<Record<number, boolean>>) => void
  currentPlant?: {id: number; name: string}
}

export function CheckableList(props: CheckableListProps) {
  const intl = useIntl()

  return (
    <div>
      <List
        className="todo__filters__list"
        itemLayout="horizontal"
        dataSource={[...(props.elements || [])]}
        renderItem={(item) => (
          <List.Item>
            <div>
              <Checkbox
                checked={props.checkedElements[item.id]}
                onChange={(e) => {
                  const {checked} = e.target

                  props.setCheckedElements({
                    ...props.checkedElements,

                    [item.id]: checked,
                  })
                }}
              >
                {item.name}
              </Checkbox>
            </div>
          </List.Item>
        )}
      />
    </div>
  )
}

export type CheckableListFormItemProps = {
  value?: CheckableListProps['checkedElements']
  onChange?: CheckableListProps['setCheckedElements']
  elements?: CheckableListProps['elements']
  currentPlant?: {id: number; name: string}
}

export function CheckableListFormItem(props: CheckableListFormItemProps) {
  return (
    <CheckableList
      elements={props.elements}
      checkedElements={props.value || {}}
      setCheckedElements={props.onChange || (() => {})}
      currentPlant={props.currentPlant}
    />
  )
}
